<div id="leave-imp" class="staff-parameter-block">
    <h3>Parámetros</h3>

    <!-- File -->
    <div class="parameter-item-list">
        <div class="parameter-each file-uploader">
            <mat-label class="upload-label">Fichero</mat-label>
            <div class="upload-wrapper">
                <!--<input type="file" class="file-input" #fileUpload placeholder="upload file" accept=".xlsx"-->
                       <input type="file" class="file-input" #fileUpload placeholder="upload file" accept="{{FileFormatEnum.LeaveImportController}}"
                    (change)="onFileChange($event.target.files)" multiple="false">
                <div class="file-upload">
                    <button mat-raised-button color="accent" class="upload-btn"
                        (click)="fileUpload.value='';fileUpload.click()">
                        <mat-icon>cloud_upload</mat-icon>
                    </button>
                </div>
                <span *ngIf="selectedFileName" class="no-msg">{{selectedFileName}}</span>
            </div>
        </div>
    </div>

    <!-- Parameters Form -->
    <form [formGroup]="parametersForm">
        <!-- <p>myForm value: {{ parametersForm.value | json }}</p> -->
        <div class="parameter-item-list">
            <div class="parameter-each fomatter">
                <mat-form-field appearance="fill">
                    <mat-label class="label">Formato</mat-label>
                    <mat-select formControlName="Formato">
                        <mat-option *ngFor="let option of templatesList" [value]="option.value">
                            {{option.label}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="button-wrapper">
                    <button (click)="onTemplateSaveClick.emit(null)">
                        <mat-icon>save</mat-icon>
                    </button>
                    <button (click)="onTemplateDeleteClick.emit(null)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>

            <div class="parameter-each width-d">
                <mat-form-field appearance="fill">
                    <mat-label>Tipo de importación</mat-label>
                    <mat-select formControlName="TipoDeImportacion">
                        <mat-option *ngFor="let option of dropDowns.TipoDeImportacion" [value]="option.value">
                            {{option.label}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="parameter-each width-s">
                <mat-label>Primera fila</mat-label>
                <mat-form-field class="example-full-width">
                    <input matInput type="number" value="2" min="1" max="20000" formControlName="PrimeraFila">
                    <mat-error>
                        <span class="validation-span">Inválido</span>
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="parameter-each width-s">
                <mat-label>Columna clave</mat-label>
                <mat-form-field class="example-full-width">
                    <input matInput type="number" value="1" min="1" max="200" formControlName="ColumnaClave">
                    <mat-error>
                        <span class="validation-span">Inválido</span>
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="parameter-each width-s">
                <mat-label>Nº de hojas</mat-label>
                <mat-form-field class="example-full-width">
                    <input matInput type="number" value="1" min="1" max="16" formControlName="Hojas">
                    <mat-error>
                        <span class="validation-span">Inválido</span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="parameter-item-list">
            <div class="parameter-each width-d">
                <mat-form-field appearance="fill">
                    <mat-label>Avisos de baja y alta</mat-label>
                    <mat-select formControlName="AvisosDeBaja">
                        <mat-option *ngFor="let option of dropDowns.AvisoDeBaja" [value]="option.value">
                            {{option.label}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="parameter-each width-d">
                <mat-form-field appearance="fill">
                    <mat-label>Tareas</mat-label>
                    <mat-select formControlName="Tareas" (selectionChange)="onTareaChange()">
                        <mat-option *ngFor="let option of dropDowns.Tareas" [value]="option.value">
                            {{option.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="parametersForm.controls.Tareas.touched && parametersForm.controls.Tareas.errors">
                        Obligatorio
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="parameter-each width-d"
                *ngIf="parametersForm.controls.Tareas.value === TareasEnum.SegunCriterios">
                <mat-form-field>
                    <mat-label>Criterios de tareas</mat-label>
                    <mat-select formControlName="Criterios">
                        <mat-option *ngFor="let option of dropDowns.CriteriosDeTareas" [value]="option.value">
                            {{option.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Los criterios de las tareas no están especificados
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="parameter-each width-d">
                <mat-form-field appearance="fill">
                    <mat-label>Acción sin teléfono</mat-label>
                    <mat-select formControlName="SinTelefono">
                        <mat-option *ngFor="let option of dropDowns.SinTelefono" [value]="option.value">
                            {{option.label}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="parameter-each width-n checkbox-block">
                <section class="example-section">
                    <mat-checkbox class="example-margin" formControlName="ActualizarTrabajador">
                        Actualizar trabajador
                    </mat-checkbox>
                </section>
            </div>

            <div class="parameter-each width-n checkbox-block">
                <section class="example-section">
                    <mat-checkbox class="example-margin" formControlName="ActualizarMobilidad">
                        Actualizar mobilidad (baja)
                    </mat-checkbox>
                </section>
            </div>

            <div class="parameter-each width-n checkbox-block">
                <section class="example-section">
                    <mat-checkbox class="example-margin" formControlName="ActualizarEmpresa">
                        Actualizar empresa
                    </mat-checkbox>
                </section>
            </div>

            <div class="parameter-each width-l checkbox-block">
                <section class="example-section">
                    <mat-checkbox class="example-margin" formControlName="ActualizarReferencia">
                        Actualizar siempre la referencia del trabajador
                    </mat-checkbox>
                </section>
            </div>

            <div class="parameter-each width-n checkbox-block">
                <section class="example-section">
                    <mat-checkbox class="example-margin" formControlName="ActualizarTipoBaja">
                        Actualizar tipo de baja
                    </mat-checkbox>
                </section>
            </div>

            <div class="parameter-each width-l checkbox-block">
                <section class="example-section">
                    <mat-checkbox class="example-margin" formControlName="ActualizarIdentificadores">
                        No comprobar errores de identificación
                    </mat-checkbox>
                </section>
            </div>

        </div>
        <div class="parameter-item-list parameter-item-list-bottom">
            <div class="parameter-each width-s">
                <mat-label>Días PV</mat-label>
                <mat-form-field class="example-full-width">
                    <input matInput type="number" value="1" min="0" max="30" formControlName="Dias">
                    <mat-error>
                        <span class="validation-span">Inválido</span>
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="parameter-each width-n">
                <mat-form-field appearance="fill">
                    <mat-label>Fecha aviso</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="FechaAviso">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </form>

    <!-- Tipo De Baja Table -->
    <div class="leave-tbl">
        <h3>Tipos de baja <button class="add-new" type="button" (click)="onTipoBajaAdd()">+</button></h3>
        <table mat-table [dataSource]="tipoDeBajasFromArray.controls">
            <caption></caption>
            <ng-container matColumnDef="tipoBaja">
                <th mat-header-cell *matHeaderCellDef> Tipo de baja </th>
                <td mat-cell *matCellDef="let element">
                    <mat-form-field class="full-width" appearance="fill">
                        <input type="text" matInput placeholder="" maxlength="1"
                            [formControl]="element.controls.tipoBaja">
                    </mat-form-field>
                    <mat-error *ngIf="element.controls.tipoBaja.touched && element.controls.tipoBaja.errors">
                        Obligatorio
                    </mat-error>
                </td>
            </ng-container>
            <ng-container matColumnDef="excel">
                <th mat-header-cell *matHeaderCellDef> Valor en Excel </th>
                <td mat-cell *matCellDef="let element">
                    <mat-form-field class="full-width" appearance="fill">
                        <input type="text" matInput placeholder="" maxlength="50"
                            [formControl]="element.controls.excel">
                    </mat-form-field>
                    <mat-error *ngIf="element.controls.excel.touched && element.controls.excel.errors">
                        Obligatorio
                    </mat-error>
                </td>
            </ng-container>
            <ng-container matColumnDef="options">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                    <button (click)="onTipoDeBajaDelete(element)">
                        <mat-icon>delete_forever</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="tipoDeBajaTableColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: tipoDeBajaTableColumns;"></tr>
        </table>
    </div>
</div>